import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import type { Appointment } from "@/hooks/useAppointments";

export const useClientAppointments = (statusGroup?: string[]) => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["client-appointments", user?.id, statusGroup],
    queryFn: async () => {
      if (!user) return [];
      let query = supabase
        .from("appointments")
        .select("*")
        .eq("client_user_id", user.id)
        .order("starts_at", { ascending: false });

      if (statusGroup && statusGroup.length > 0) {
        query = query.in("status", statusGroup);
      }

      const { data, error } = await query;
      if (error) throw error;

      const artisanIds = [...new Set((data as Appointment[]).map((a) => a.artisan_user_id))];
      const { data: profiles } = artisanIds.length
        ? await supabase
            .from("profiles")
            .select("user_id, first_name, last_name")
            .in("user_id", artisanIds)
        : { data: [] };

      const nameMap: Record<string, string> = {};
      (profiles || []).forEach((p) => {
        nameMap[p.user_id] = `${p.first_name} ${p.last_name}`.trim();
      });

      return (data as Appointment[]).map((apt) => ({
        ...apt,
        other_name: nameMap[apt.artisan_user_id] || "Artisan",
      }));
    },
    enabled: !!user,
  });
};
